import { defineMessages } from 'react-intl';

export const SensorScanStepContent = defineMessages({
  scanSuccess: {
    id: 'app.common.scanSuccess',
    defaultMessage: 'QR kód úspěšně naskenován',
  },
  title: {
    id: 'app.SensorScanStepContent.title',
    defaultMessage: 'Naskenuj QR kód senzoru nebo zadej jeho {serialNumber}',
  },
  datasourceIdRequired: {
    id: 'app.SensorScanStepContent.datasourceIdRequired',
    defaultMessage: 'Je třeba vyplnit {serialName}!',
  },
  dataSourcePlaceholder: {
    id: 'app.SensorScanStepContent.dataSourcePlaceholder',
    defaultMessage: 'Načtený QR kód',
  },
});

export const SensorScanStepFooter = defineMessages({
  back: {
    id: 'app.common.back',
    defaultMessage: 'Zpět',
  },
  continue: {
    id: 'app.common.continue',
    defaultMessage: 'Pokračovat',
  },
  verifyConnection: {
    id: 'app.common.verifyConnection',
    defaultMessage: 'Ověřit připojení',
  },
});
